import defaults from './default';
import es from './es';

// Lenguaje por default en
export const en_messages = {
	...defaults,
};

export const es_messages = {
	...es,
};
